import styled from '@emotion/styled';

const Container = styled.div`
  margin-bottom: 20px;
  background: #fff;
  box-shadow: 0 0 0 1px #00000019, 0 2px #00000006;
  border-radius: 4px;
`;

export default Container;
